import React from 'react';
import { useContext, useEffect } from "react";
import * as FaIcons from 'react-icons/fa';
import findBrand from "../findBrand";
import { getsites } from "../findBrand";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";


const CompleteMessage = () => {
  // Move brandName inside component to ensure fresh value
  const brandName = getsites();
  const navigate = useNavigate();
  const location = useLocation();

  // Get site ID from URL query parameters
  const query = queryString.parse(location.search);
  const siteId = query.site;

  // // Navigate to information page
  // const handleGoToInformation = () => {
  //   navigate(`/information?site=${siteId}`);
  // };

  // // Navigate to home page (map/site list)
  // const handleGoToHome = () => {
  //   navigate("/");
  // };



  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Normalize the brand name (trim whitespace, convert to lowercase)
  const normalizedBrandName = brandName?.toString().trim().toLowerCase();
  //console.log('Normalized Brand Name:', normalizedBrandName);
  if (normalizedBrandName === "learn4life") {
    return (
      <div className='complete-message'>
        <div className="success-container">
        <h1 className="success-title">Info Kit Sent!</h1>
          <p className="success-description">Thanks for requesting your Learn4Life Info Kit—check your inbox shortly!</p>
         <div className="links-section">
     <p className="success-description">Want to learn more while you wait?</p>
            <a href="https://learn4life.org/personalized-learning/programs/" className="success-link" target="_blank" rel="noopener noreferrer">
              Explore Our Programs
            </a>
            <a href="https://learn4life.org/student-stories/" className="success-link" target="_blank" rel="noopener noreferrer">
              Read Student Success Stories
            </a>
            <a href="https://alive5.com/Wky9Rmj" className="success-link" target="_blank" rel="noopener noreferrer">
              Connect With a Team Member
            </a>
          </div>
          <p className="success-description">We're here when you're ready to take the next step.</p>
        </div>
        <div className="complete-buttons-container">
          {siteId && (
            <button className='btninfo' onClick={() => navigate(-1)}>
              <FaIcons.FaInfoCircle />
              Go to Information Page
            </button>
          )}
          <button className='Homeinfo' onClick={() => navigate('/')}>
            <FaIcons.FaHome />
            Go to Home Page
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className='complete-message' >
        <div className="success-container">
          <h1 className="success-title">You're All Set!</h1>
          <p className="success-description">
            Thank you, your submission has been received.
          </p>
          <p className='success-description'>
            A team member will reach out to you within one business day.
          </p>

        </div>
        <div className="complete-buttons-container">
          {siteId && (
            <button className='btninfo' onClick={() => navigate(-1)}>
              <FaIcons.FaInfoCircle />
              Go to Information Page
            </button>
          )}
          <button className='Homeinfo' onClick={() => navigate('/')}>
            <FaIcons.FaHome />
            Go to Home Page
          </button>
        </div>
      </div>
    );
  }
};

export default CompleteMessage;